import store from '../store'
import moment from 'moment'
import LogRocket from 'logrocket';
import i18n from '@/lang/i18n';
import EXIF from 'exif-js';

import font from '@/pdffont/font.js'

const HEADER_ELEMENT_HEIGHT = 50;
const SPACE_PATIENT_TAB_AREA_WITH_TOP = 240 //space the top tab's area with the top area scrolling
const HEIGHT_OF_SPACE_AREA = 931 // height of paper - padding top bottom - header - end line = 1123 - 40 - 110 - 42
const HEIGHT_DEFAULT_OF_IMAGE_AREA = 730
const HEIGHT_OF_ROW_WITHOUT_DATA = 40
const HEIGHT_OF_TITLE_ROW = 40

function correctColumnWidthData(widthTable, arrayLength) {
    //Caculate the with of each column below the chart
    let widthList = [];
    let widthColumn = widthTable/arrayLength
    let roudWidth = Math.round(widthColumn)
    let startWidthColumn = 0
    let fixWidthColumn = 0
    let errorNumber = 0
    if (widthColumn > roudWidth) {
      startWidthColumn = roudWidth
      fixWidthColumn = roudWidth + 1
      
      errorNumber = widthTable - (roudWidth * arrayLength)
    } else {
      startWidthColumn = roudWidth
      fixWidthColumn = roudWidth - 1
  
      errorNumber = (roudWidth * arrayLength) - widthTable
    }
  
    let stepUpdate = arrayLength / errorNumber
  
    for (let i=0; i<arrayLength; i++) {
      if (i >= stepUpdate) {
        widthList[i] = fixWidthColumn
        stepUpdate += arrayLength / errorNumber
      } else {
        widthList[i] = startWidthColumn
      }
    }
    return widthList
}

function getRangeColorForMedicineAmount(listAmount) {
  listAmount = [...new Set(listAmount.sort((a,b) => {return a - b})) ]
  switch(listAmount.length) {
  //if don't have, or just have one amount, rangeColor will be null
    case 0:
    case 1:
      return []
    //if have 2 amount, rangeColor is the smallest amount
    case 2:
      return [ listAmount[0] ]
    //if have more than 2 amount, rangeColor are two smallest amount
    default:
      return [ 
        listAmount[0],
        listAmount[1],
      ]
  }
}

function getMedicineColorForMedicineAmount(medicineColors, medicineName, amount, rangeColor, is_multi_ingredient) {
  const medicineColor = medicineColors.find((item) => item.medicine_name === medicineName)
  // don't have amount, show bold color
  // 1 amount, show slight color
  // 2 amount, show slight and normal color
  // 3 amount, show slight, norrmal and bold color
  // if multi ingredient, show slight color 
  if (medicineColor) {
    if (is_multi_ingredient) {
      return medicineColor.dr_site_color_slight
    }
    else if(!amount) {
      return medicineColor.dr_site_color_bold
    }
    else {
      switch (rangeColor.length) {
        case 0:
          return medicineColor.dr_site_color_slight
        case 1:
          return amount > rangeColor[0] ? medicineColor.dr_site_color_normal : medicineColor.dr_site_color_slight
        case 2:
          return amount > rangeColor[1] ? medicineColor.dr_site_color_bold : amount > rangeColor[0] ? medicineColor.dr_site_color_normal : medicineColor.dr_site_color_slight
        default:
          return medicineColor.dr_site_color_bold
      }
    }
  }
  return '#FF89C0'
}

function makeMedicineBarForMedicineAmount(medicineTaken, filterTypeActive, tableWidth, medicineColors, isPDFPage) {
  let tableMedicationTaken = document.getElementById("medication-taken-list")
  tableMedicationTaken.innerHTML = ''
  let newRow = ''
  // var width = 100/labels.length
  var showMedicationTitle = true
  for (const [medicineName, medicineData] of Object.entries(medicineTaken)) {
    let rangeColor = getRangeColorForMedicineAmount(medicineData.listAmount)
    newRow += `<div class="medication-taken" style="display: flex; margin-top:5px;">
                  <div ${isPDFPage ? 'class="fs10" style="padding-right: 15px; min-width: 80px"' : 'style="padding-right: 15px; min-width: 100px"'}>`+ (showMedicationTitle ? i18n.t('medicines_being_taken') : "") + `</div>
                    <div class="w-100">
                      <div ${isPDFPage ? '' : 'class="chart-medicine-name" style="font-size: 0.8rem;"'}></div>`
    if(filterTypeActive == 0) {
      medicineData.listAmount.forEach((amount, index) => {
        let content = ''
        let span = ''
        let isMultiDate = false
        if (medicineData.listStartDate && medicineData.listEndDate) isMultiDate = true
        if (medicineData.is_multi_ingredient) {
          content = i18n.t('cannot_be_displayed_because_it_is_a_combination_lock')
          span = `<span class="tooltip-for-medicine-taken" style="right: 0px; top: -30px;">
                    ${i18n.t('cannot_be_displayed_because_it_is_a_combination_lock')}
                  </span>`
        }
        else if (typeof amount === 'number' || amount === null) {
          content = ( !medicineData.is_external && medicineData.total_ingredient != 0 ) ? (amount > 0 ? (amount + medicineData.unit) : i18n.t('application_not_entered')) : ''
          span = `<span class="tooltip-for-medicine-taken" style="right: 0px; top: -30px;">
                    ${isMultiDate ? medicineData.listStartDate[index] : medicineData.start_date} ~ ${isMultiDate ? (medicineData.listEndDate[index] !== null ? medicineData.listEndDate[index] : '' ) : (medicineData.end_date !== null ? medicineData.end_date : '')}<br>
                    ${medicineName}<br>
                    ${content}
                  </span>`
        }
        newRow += `<table class="show-medication-taken show-table" style=" ${isPDFPage ? 'height: 18px; width: '+(tableWidth - 80)+'px;' : 'height: 20px; width: '+(tableWidth - 100)+'px;'} border-collapse: collapse; position: relative; border-collapse:separate; border-spacing: 0 5px;">
                    <tr>
                      <td
                        class="${typeof amount === 'number' || amount === null || medicineData.is_multi_ingredient ? 'has-tooltip' : ''}"
                        style="
                          text-align: ${ !isPDFPage ? 'left' : 'center' };
                          ${ !isPDFPage ? 'padding-left: 5px;' : '' };
                          background-color: ${getMedicineColorForMedicineAmount(medicineColors, medicineName, amount, rangeColor, medicineData.is_multi_ingredient)};
                        "
                      >
                      ${medicineName}&nbsp${content}
                      ${ !isPDFPage ? span : ''}
                      </td>
                    </tr>
                  </table>`
      })
    }
    else {
      let colspan = 1
      let widthOfOneCol = (tableWidth - (isPDFPage ? 80 : 100)) / medicineData.data.length
      let listAmountDisplayed = []
      let listAmountAlreadyExistsInThisTime = []
      let amountIsShowing = undefined
      while(medicineData.listAmountWithId.length != listAmountDisplayed.length) {
        newRow += `<table class="show-medication-taken show-table" style=" ${isPDFPage ? 'height: 18px; width: '+(tableWidth - 80)+'px;' : 'height: 20px; width: '+(tableWidth - 100)+'px;'} border-collapse: collapse; position: relative; border-collapse:separate; border-spacing: 0 5px;">
                    <tr>`
        listAmountAlreadyExistsInThisTime = listAmountDisplayed
        medicineData.data.forEach((col, colIndex) => {
          amountIsShowing = amountIsShowing === undefined ? col?.find(a => !listAmountAlreadyExistsInThisTime.some( el => el.amount == a.amount && el.id == a.id) ) : amountIsShowing
          listAmountAlreadyExistsInThisTime = (col == null ? listAmountAlreadyExistsInThisTime : listAmountAlreadyExistsInThisTime.concat(col))
          if(col != null && amountIsShowing !== undefined) {
            // increase colspan and skip this loop if next loop have same amount with this
            if (medicineData.data[colIndex+1]?.some( el => el.amount == amountIsShowing.amount && el.id == amountIsShowing.id)) {
              colspan ++
              return
            }
            // remainingWidth is the value use for position-absolute-right for each span tooltip
            let remainingWidth = (medicineData.data.length - 1 - colIndex) * widthOfOneCol
            let content = ''
            let span = ''
            let data = []
            let arrDate = []
            let amountAndUnit = ''
            //show text if medicine is multi-ingredient 
            if (medicineData.is_multi_ingredient) {
              content = i18n.t('cannot_be_displayed_because_it_is_a_combination_lock')
              span = `<span class="tooltip-for-medicine-taken" style="right:${remainingWidth}px; top: -30px;">
                        ${i18n.t('cannot_be_displayed_because_it_is_a_combination_lock')}
                      </span>`
            }
            // or show amount if the medicine have amount
            else if (typeof amountIsShowing.amount === 'number' || amountIsShowing.amount === null) {
              amountAndUnit = ( !medicineData.is_external && medicineData.total_ingredient != 0 ) ? (amountIsShowing.amount > 0 ? amountIsShowing.amount + medicineData.unit : i18n.t('application_not_entered')) : ''
              content = widthOfOneCol * colspan > 9 ? amountAndUnit : ''
              medicineData.listAmountWithId.forEach(value => {
                data.push(value)
              });
              data.map(x => x.id === amountIsShowing.id ? arrDate.push([x.medicine_start_date], [x.medicine_end_date]) : [])
              span = `<span class="tooltip-for-medicine-taken" style="right:${remainingWidth}px; top: -30px;">
              ${arrDate[0]} ~ ${arrDate[1] !== null ? arrDate[1] : ''}<br>
              ${medicineName}<br>
              ${content}
              </span>`
            }

            newRow += `<td colspan="${colspan}"
                        class="${(typeof amountIsShowing.amount === 'number' || amountIsShowing.amount === null || medicineData.is_multi_ingredient) ? 'has-tooltip' : ''}"
                        style="
                          max-width:${widthOfOneCol * colspan}px;
                          min-width:${widthOfOneCol * colspan}px;
                          text-align: ${ !isPDFPage ? 'left' : 'center' };
                          ${ !isPDFPage ? 'padding-left: 5px;' : '' };
                          background-color: ${getMedicineColorForMedicineAmount(medicineColors, medicineName, amountIsShowing.amount, rangeColor, medicineData.is_multi_ingredient)};
                        "
                      >
                        ${medicineName}&nbsp${content}
                        ${ !isPDFPage ? span : ''}
                      </td>`
            colspan = 1
            listAmountDisplayed.push(amountIsShowing)
            amountIsShowing = undefined
          }
          else {
            newRow += `<td style="width:${widthOfOneCol}px;"></td>`
            colspan = 1
          }
        })
        newRow += '</tr></table>'
      }
    }
    newRow += `</div>
            </div>`
    showMedicationTitle = false;
  }
  tableMedicationTaken.insertAdjacentHTML('beforeend', newRow)
  Array.from(document.getElementsByClassName('has-tooltip')).forEach( element => {
    element.addEventListener('mousemove', (event) => {
      let scrollPosition = document.getElementsByClassName('graph-inner-area')[0].scrollLeft
      let tooltipSpan = element.getElementsByTagName('span')[0] 
      let leftCol = document.getElementById('m-left-col').offsetWidth + 110
      let widthChart = document.getElementById('chart-js').offsetWidth - 400
      if (scrollPosition + event.pageX - leftCol > widthChart) {
        tooltipSpan.style.left = widthChart + "px"
      } else {
        tooltipSpan.style.left = (scrollPosition + event.pageX - leftCol) +"px";
      }
    });
  })
}

function makeMedicineBarForMedicineAmountForPDF(medicineTaken, filterTypeActive, tableWidth, medicineColors, maxHeightForMedicineList, rowShowed) {
  const HEIGHT_OF_MEDICINE_NAME = 25
  const HEIGHT_OF_AMOUNT_ELEMENT = 32
  let currentRowShowed = 0
  let stillHaveData = false
  let newRow = ''
  // var width = 100/labels.length
  var showMedicationTitle = true
  for (const [medicineName, medicineData] of Object.entries(medicineTaken)) {
    if(maxHeightForMedicineList - HEIGHT_OF_MEDICINE_NAME <= HEIGHT_OF_AMOUNT_ELEMENT) {
      stillHaveData = true
      break
    }
    currentRowShowed ++
    let rangeColor = getRangeColorForMedicineAmount(medicineData.listAmount)
    newRow += `<div class="medication-taken" style="display: flex; ${ currentRowShowed > rowShowed ? 'margin-top:5px;' : ''}">
                  <div class="fs10" style="padding-right: 15px; min-width: 80px">`+ (showMedicationTitle && rowShowed == 0 ? i18n.t('medicines_being_taken') : "") + `</div>
                  <div class="w-100">`
    if(currentRowShowed > rowShowed) {
      maxHeightForMedicineList -= HEIGHT_OF_MEDICINE_NAME
      newRow += `<div>`+ medicineName + `</div>`
    }
    if(filterTypeActive == 0) {
      medicineData.listAmount.forEach((amount, index) => {
        if(maxHeightForMedicineList - HEIGHT_OF_AMOUNT_ELEMENT <= 0) {
          stillHaveData = true
          return
        }
        currentRowShowed ++
        if(currentRowShowed > rowShowed) {
          let content = ''
          if (medicineData.is_multi_ingredient) {
            content = i18n.t('cannot_be_displayed_because_it_is_a_combination_lock')
          }
          else if (typeof amount === 'number' || amount === null) {
            content = ( !medicineData.is_external && medicineData.total_ingredient != 0 ) ? (amount > 0 ? amount + medicineData.unit : i18n.t('application_not_entered')) : ''
          }
          newRow += `<table class="show-medication-taken show-table" style=" ${'height: 18px; width: '+(tableWidth - 80)+'px;'} border-collapse: collapse; position: relative; border-collapse:separate; border-spacing: 0 5px;">
                      <tr>
                        <td
                          class="${typeof amount === 'number' || amount === null || medicineData.is_multi_ingredient ? 'has-tooltip' : ''}"
                          style="
                            background-color: ${getMedicineColorForMedicineAmount(medicineColors, medicineName, amount, rangeColor, medicineData.is_multi_ingredient)};
                          "
                        >
                          ${content}
                        </td>
                      </tr>
                    </table>`
          maxHeightForMedicineList -= HEIGHT_OF_AMOUNT_ELEMENT
        }
      })
    }
    else {
      let colspan = 1
      let widthOfOneCol = (tableWidth - 80) / medicineData.data.length
      let listAmountDisplayed = []
      let listAmountAlreadyExistsInThisTime = []
      let amountIsShowing = undefined
      while(medicineData.listAmountWithId.length != listAmountDisplayed.length) {
        if(maxHeightForMedicineList - HEIGHT_OF_AMOUNT_ELEMENT <= 0) {
          stillHaveData = true
          break
        }
        currentRowShowed ++
        let rowData = ''
        rowData += `<table class="show-medication-taken show-table" style="${'height: 18px; width: '+(tableWidth - 80)+'px;'} border-collapse: collapse; position: relative; border-collapse:separate; border-spacing: 0 5px;">
                    <tr>`
        listAmountAlreadyExistsInThisTime = listAmountDisplayed
        medicineData.data.forEach((col, colIndex) => {
          amountIsShowing = amountIsShowing === undefined ? col?.find(a => !listAmountAlreadyExistsInThisTime.some( el => el.amount == a.amount && el.id == a.id) ) : amountIsShowing
          listAmountAlreadyExistsInThisTime = (col == null ? listAmountAlreadyExistsInThisTime : listAmountAlreadyExistsInThisTime.concat(col))
          if(col != null && amountIsShowing !== undefined) {
            // increase colspan and skip this loop if next loop have same amount with this
            if (medicineData.data[colIndex+1]?.some( el => el.amount == amountIsShowing.amount && el.id == amountIsShowing.id)) {
              colspan ++
              return
            }
            let content = ''
            //show text if medicine is multi-ingredient 
            if (medicineData.is_multi_ingredient) {
              content = i18n.t('cannot_be_displayed_because_it_is_a_combination_lock')
            }
            // or show amount if the medicine have amount
            else if (typeof amountIsShowing.amount === 'number' || amountIsShowing.amount === null) {
              var amountAndUnit = ''
              amountAndUnit = ( !medicineData.is_external && medicineData.total_ingredient != 0 ) ? (amountIsShowing.amount > 0 ? amountIsShowing.amount + medicineData.unit : i18n.t('application_not_entered')) : ''
              content = widthOfOneCol * colspan > 9 ? amountAndUnit : ''
            }

            rowData += `<td colspan="${colspan}"
                        class="${typeof amountIsShowing.amount === 'number' || amountIsShowing.amount === null || medicineData.is_multi_ingredient ? 'has-tooltip' : ''}"
                        style="
                          max-width:${widthOfOneCol * colspan}px;
                          min-width:${widthOfOneCol * colspan}px;
                          background-color: ${getMedicineColorForMedicineAmount(medicineColors, medicineName, amountIsShowing.amount, rangeColor, medicineData.is_multi_ingredient)};
                        "
                      >
                        ${content}
                      </td>`
            colspan = 1
            listAmountDisplayed.push(amountIsShowing)
            amountIsShowing = undefined
          }
          else {
            rowData += `<td style="width:${widthOfOneCol}px;"></td>`
            colspan = 1
          }
        })
        rowData += '</tr></table>'
        if(currentRowShowed > rowShowed) {
          maxHeightForMedicineList -= HEIGHT_OF_AMOUNT_ELEMENT
          newRow += rowData
        }
      }
    }
    newRow += `</div>
            </div>`
    showMedicationTitle = false;
  }
  return {data: newRow, rowShowed: currentRowShowed, stillHaveData: stillHaveData}
}

function parseJwt (token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))

  return JSON.parse(jsonPayload);
}

function getToken() {
  return store.state.auth.token
}

function isExpiredToken() {
  const now = moment().format('x')
  const expired = parseJwt(getToken()).exp * 1000
  return expired < now
}

/**
 * NOTE
 * @deprecated This function is no longer used. Please use isExpiredToken instead.
 */
function isRefreshToken () {
  if (!getToken()) return false
  if (store.state.auth.typeOfUser === 'pharmacy') return isExpiredToken()
  return store.state.auth.rememberMe && isExpiredToken()
}

/**
 * Should we fire off a refresh-token request?
 * @returns {boolean}
 */
export function shouldRefreshToken() {
  const token = getToken()
  return !!token && isExpiredToken()
}

function isLogout () {
  return !getToken()
}

function isLogin () {
  if (getToken() && !isExpiredToken()) return true
  return false
}
function setLogRocket(email) {
  LogRocket.init(process.env.MIX_LOG_ROCKET_ID);
  LogRocket.identify(email + ' (' + (process.env.MIX_LOCALE === 'en' ? 'VN' : 'JP') + ')', {
    email: email,
    locale: process.env.MIX_LOCALE === 'en' ? 'VN' : 'JP'
  });
}

function getOffset( el ) {
  var _x = 0;
  var _y = 0;
  while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
    _x += el.offsetLeft - el.scrollLeft;
    _y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: _y, left: _x };
}

function scrollToElement(activeTab, additionalStats = 0) {
  let scrollY = getOffset(document.getElementById(activeTab)).top + additionalStats
  window.scrollTo({
    top: scrollY,
    left: 0,
    behavior: 'smooth'
  });
}

function convertToJPTime(time) {
  const [year, month, dateTime] = time.split('-')
  const [date] = dateTime.split(' ')
  const data = year + '年' + month + '月' + date + '日 '
  return data
}

function convertToJPDateTime(time) {
  const [year, month, dateTime] = time.includes('-') ? time.split('-') : time.split('/')
  const [date, times] = dateTime.split(' ')
  const data = i18n.t('year_month_date_time', {year: year, month: month, date: date, times: times})
  return data
}

function params(type, name, action, childId, time = null) {
  let params = {
    group_type: type,
    group_name: name,
    action: action,
    childId: childId,
    answer_date_time: time
  }
  return params
}

async function getInfoAndBasicInfo(id) {
  await store.dispatch("patient/getBasicInfoByChildId", id)
  await store.dispatch("homeCareBook/getBasicInfo", { params: params('basic_info', 'base', 'get_latest', id) })
}

function getHomecareInsulinUnit(data, index = null) {
  if(index != null) {
    switch (index) {
      case 0:
        return (data && data[0] != null && data[0] != 'ー') ? data[0] : 'その他'
      case 1:
        return (data && (typeof data[1] === 'number' || data[1] === 0)) ? (data[1] + '単位') : 'ー'
    }
  }
  else {
    return ((data && typeof data === 'number') || data === 0) ? (data + '単位') : 'ー'
  }
}

function updatePageNumber(){
  let listPageHeader = document.querySelectorAll('.fRight')
  listPageHeader.forEach((el, index) => {
    el.innerHTML = el.innerHTML.replace('00/00', (index+1)+'/'+listPageHeader.length)
    el.className = 'fRight visible'
  });
}

async function exportFileToPDF(KidNickname, pageName, flag) {

  var doc = new jsPDF({
    orientation: 'p',
    unit: 'pt',
    format: 'a4',
    compress: true
  });

  doc.addFileToVFS( 'SourceHanSansCN-Normal-normal.ttf', font );
  doc.addFont('SourceHanSansCN-Normal-normal.ttf', 'SourceHanSansCN-Normal', 'normal');
  doc.setFont( 'SourceHanSansCN-Normal', 'normal' );

  let pageHeight = 0;
  switch(flag) {
    case 'homecare' : {
      //homecare info
      var pages = document.getElementsByClassName('list-page-homecare-pdf pt-3')[0].children;
      break;
    }
    case 'vaccin' : {
      // vaccin info
      var pages = document.getElementsByClassName('list-page-vacccin-pdf pt-3 pt-3')[0].children;
      break;
    }
    case 'allergy' : {
      // allergy info
      var pages = document.getElementsByClassName('list-page-allergy-pdf pt-3')[0].children;
      document.getElementsByClassName('header heghtHeader')[0].style.width = '754px';

      // table data 
      var thirdScreenShot = document.getElementsByClassName('table-pediatric')[0];
      await screenShotElement(thirdScreenShot);
      break;
    }
  }
  const currentDate = moment().format('YYYY/MM/DD HH:mm').split(' ')[0].match(/\d+/g).join('')
  let fileName = 'nanacara_' + currentDate + '_' + KidNickname + '_' + pageName;
  
  await printPDF(doc, pages, fileName, pageHeight, flag);
}

async function screenShotElement(element) {
  await html2canvas(
    element, {
      letterRendering: true,
      useCORS: true,
      scale: 1,
      dpi: 300,
    }
  ).then(async function(canvas) {
    let ctx = canvas.getContext('2d');
    ctx.webkitImageSmoothingEnabled = false;
    ctx.mozImageSmoothingEnabled = false;
    ctx.imageSmoothingEnabled = false;
    const dataURL = canvas.toDataURL('image/png', 1)

    let img = document.createElement("img");
    img.src = dataURL;
    img.style.height = '100%';
    img.style.width = '100%';

    element.innerHTML = '';
    element.appendChild(img);
  });
}

async function printPDF(doc, pages, fileName, pageHeight = 0, pagePrintName = null) {
  for await (var element of pages) {
    if (!element.hasChildNodes()) {
      continue;
    }

    let fRight = element.getElementsByClassName('fRight');
    let paginate = fRight[fRight.length -1].innerHTML.split(' ')[4].split('/');
    
    let currentPage = parseInt(paginate[0]);
    let totalPage = parseInt(paginate[1]);
    let isLastPage = currentPage == totalPage;
    
    if (pagePrintName == 'homecare') {
      let images = element.getElementsByTagName('img');
      if (images.length > 0) { 
        await replaceRotateImages(images);
      }
    }
    
    let hasPage = Math.floor(element.offsetHeight / 1123) == 0 ? 1 : Math.floor(element.offsetHeight / 1123);

    element.style.fontFamily = 'SourceHanSansCN-Normal';

    for (let i = 1; i <= hasPage; i++) {
      if (!isLastPage) {
        await doc.addPage();
      }
    }

    await doc.html(element , {
        callback: function ( newDoc ) {
          return newDoc;
        },
        html2canvas : {
          scale : 0.733,
        },
        margin: [0, 4, 0, 4],
        x: 0,
        y: pageHeight,
    });

    pageHeight += doc.internal.pageSize.getHeight() * hasPage;
    element.style.fontFamily = 'inherit';
  }

  await doc.save(fileName);
}

async function replaceRotateImages (images) {
  let arrayPromise = [];
  let i = 1;
  for (let image of images) {
    let rotate = await new Promise((resolve, reject) => {
      EXIF.getData(image, async function() { 
        resolve(EXIF.getTag(this, "Orientation") || 1);
      });
    });

    if (rotate == 1) {
      continue;
    }

    let maxWidth = '100%';
    if ( (i % 2) != 0 && i == images.length ) {
      // alone last image
    } else if (images.length > 1) {
      maxWidth = '50%'; 
    }
    i ++;

    let newImage = document.createElement('img');
    newImage.src = image.src;
    newImage.style.maxHeight = 33 * (window.devicePixelRatio) + '%';
    newImage.style.maxWidth = 33 * (window.devicePixelRatio) + '%';

    let node = document.getElementById('app').appendChild(newImage);

    let changeImage = html2canvas(
      node, {
        letterRendering: true,
        useCORS: true,
        scale: 1,
        dpi: 300,
      }
    ).then(async function(canvas) {
      node.remove();
      const dataURL = canvas.toDataURL('image/png', 1)
  
      let img = document.createElement("img");
      img.src = dataURL;
      img.style.maxHeight = '90%';
      img.style.maxWidth = maxWidth;
  
      let parent = image.parentElement;
      parent.replaceChild(img, image);
    });
    
    arrayPromise.push(changeImage);
  }

  await Promise.all(arrayPromise).then((values) => {
    // wait for replace all rotate image
  });
}

function convertPageToCanvasAndAddToPDF(pdf, page, listPage, pagePrint, maxPage, KidNickname, pageName) {
  pagePrint.style.display = 'block'
  html2canvas(pagePrint, {
    letterRendering: true,
    useCORS: true,
    height: 1200,
    onrendered: function(canvas) {
      var dataURL = canvas.toDataURL('image/png')
      if (page > 1) {
        pdf.addPage()
        pdf.setPage(page)
      }
      pdf.addImage(canvas,'JPEG',0,0)
      pagePrint.style.display = 'none'
      page++
      if (maxPage < page) {
        const currentDate = moment().format('YYYY/MM/DD HH:mm').split(' ')[0].match(/\d+/g).join('')
        pdf.save('nanacara_' + currentDate + '_' + KidNickname + '_' + pageName)
        let divRemove = document.getElementById('export_pdf_canvas_handler')
        divRemove.parentElement.removeChild(divRemove)
      }
      else {
        convertPageToCanvasAndAddToPDF(pdf, page, listPage, listPage[page - 1], maxPage, KidNickname, pageName)
      }
    }
  })
}

function getMonthBetweenDate(from, to) {
  let dateFrom = moment(from, 'YYYY/MM/DD')
  let dateTo = moment(to, 'YYYY/MM/DD')

  let startYear = parseInt(dateFrom.format('YYYY'))
  let endYear = parseInt(dateTo.format('YYYY'))
  let startMonth = parseInt(dateFrom.format('M'))
  let endMonth = parseInt(dateTo.format('M'))

  var arrMonth = []

  for (let year = startYear; year <= endYear; year++) {
    let tempStartMonth = year === startYear ? startMonth : 1
    let tempEndMonth = year !== endYear ? 12 : endMonth

    for (let month = tempStartMonth; month <= tempEndMonth; month++) {
      arrMonth.push(moment(year + '/' + month,'YYYY/MM/DD').endOf('month').format('YYYY/MM'))
    }
  }
  arrMonth.shift()
  return arrMonth
}

const subLabelYearMonth = {
  id: 'subLabelYearMonth',
  // afterDatasetsDraw, beforeDraw, beforeRender
  afterDraw(chart) {
    const { ctx } = chart
    let xAxes = chart.scales['x-axis-0']
    let yAxes = chart.scales['y-axis-0']
    let dataLabels = chart.config.data.labels
    let arrIndexStartMonth = []
    var arrPixelMonthYearForLabels = []
    let maxHeightPixelYAxes = 0
    let minHeightPixelYAxes = 0
    let isScroll = chart.config.data.scroll || 0
    let stepTime = 0

    if (Object.keys(xAxes).length !== 0 && dataLabels && dataLabels.length !== 0) {
      if (dataLabels) {
        let temp = 0
        dataLabels.forEach((item, index) => {
          // by month and by week
          if (item.includes('/') && item.includes('~') || item.includes('月')) {
            if (temp !== parseInt(item)) {
              arrIndexStartMonth.push(index)
              temp = parseInt(item)
            }
          }
          // by date
          else if (item.includes('/') && !item.includes('~')) arrIndexStartMonth.push(index)
        })
      }
      if (isScroll === 0 && arrIndexStartMonth.length > 0) { // user not choose scroll in chartjs
        var tempStepTime = parseInt(arrIndexStartMonth.length / 10)
        if (tempStepTime > 1) stepTime = tempStepTime
      }
      if (arrIndexStartMonth && xAxes._labelItems ) {
        // Find the distance of each label
        let distance2Labels = (xAxes._endPixel - xAxes._startPixel)/dataLabels.length
        
        // Find the mid pixel score at the end of the month and the beginning of the month
        arrIndexStartMonth.forEach(item => {
          if (item !== 0) {
            if (typeof xAxes._startPixel !== 'undefined' && typeof xAxes._endPixel !== 'undefined' && distance2Labels !== 0) {
              arrPixelMonthYearForLabels.push(xAxes._startPixel + distance2Labels * parseInt(item))
            }
          }
        })
        maxHeightPixelYAxes = yAxes.maxHeight
        minHeightPixelYAxes = yAxes._startPixel
      }

      if (arrPixelMonthYearForLabels) {
        arrPixelMonthYearForLabels.forEach((item, index) => {
          if (index % stepTime === 0 || stepTime === 0) { 
            // Draw line
            ctx.beginPath();
            ctx.moveTo(item, maxHeightPixelYAxes);
            ctx.strokedStyle = 'gray'
            ctx.lineTo(item, minHeightPixelYAxes);
            ctx.stroke();

            // Set text month year together index pixel Draw line for line center 
            ctx.fillStyle = "#666666"
            ctx.textAlign = 'center'
            ctx.font = '12.8px -apple-system,BlinkMacSystemFont,"Helvetica Neue","游ゴシック Medium",YuGothic,YuGothicM,"Hiragino Kaku Gothic ProN",メイリオ,Meiryo,sans-serif'
            ctx.fillText(chart.config.data.temp_labels[index], item, maxHeightPixelYAxes + 10)
          }
        })

        ctx.save()
      }
    }
  }
}

function isTokenExemptPage(page) {
  const tokenExemptPages = [
    '/login',
    '/contact-form',
    '/info',
    '/legal/termsofuse',
    '/send-reset-link',
    '/contact-confirm',
    '/change-password',
    '/changed-password'
  ];
  
  return tokenExemptPages.includes(page);
}


function checkOldId(data, isNanacara = true) {
  const keysNanaToCheck = ['child_nanacara_id', 'family_nanacara_id'];
  const keysMediToCheck = ['child_nanamedi_id'];
  for (let key of (isNanacara ? keysNanaToCheck : keysMediToCheck)) {
    if (data?.[key]) {
      data.id = data[key];
    }
  }
  return data;
}

export {
  HEADER_ELEMENT_HEIGHT,
  SPACE_PATIENT_TAB_AREA_WITH_TOP,
  HEIGHT_OF_SPACE_AREA,
  HEIGHT_DEFAULT_OF_IMAGE_AREA,
  HEIGHT_OF_ROW_WITHOUT_DATA,
  HEIGHT_OF_TITLE_ROW,
  subLabelYearMonth,
  correctColumnWidthData,
  makeMedicineBarForMedicineAmount,
  makeMedicineBarForMedicineAmountForPDF,
  parseJwt,
  isRefreshToken,
  isLogout,
  isLogin,
  setLogRocket,
  getOffset,
  scrollToElement,
  convertToJPTime,
  convertToJPDateTime,
  params,
  getInfoAndBasicInfo,
  getHomecareInsulinUnit,
  updatePageNumber,
  exportFileToPDF,
  getMonthBetweenDate,
  isTokenExemptPage,
  checkOldId,
}
